import React, { useState, useEffect, useContext } from 'react';
import { NavigateWayContext } from '../store/NavigateWayContext';
import { Header } from '../components/header/header'
import { SearchRack } from '../components/searchRack/searchRack'
import chevronWhite from '../img/Chevron White.svg'
import chevron from '../img/chevron.svg'
import '../styles/details.css'
import noCount from '../img/noCountRoom.png'
import axiosInstance from '../auth/axiosInstance'
import { useNavigate, useParams } from 'react-router-dom'
import { dynamicReduce } from '../components/dynamicReduce'
import { ButtonLess } from '../components/button/buttonLess'
import { EditRacks } from '../components/editRacks/editRacks'
import { UseOnChange } from '../utils/onChange'
import Filter from '../components/filter copy/filter'
import { Button } from '../components/button/button'
import FooterStatus from '../components/footerStatus/footerStatus'
import { useMsal } from "@azure/msal-react";
import { tableDownload } from '../functions/tableDownload'
import Chip from "../components/chip/chip";
import newDc from "../img/newDc.svg";
import newDcCinza from "../img/newDcCinza.svg";
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';

function Details({ type }) {
    const [pdus, setPdus] = useState([])
    const [data, setData] = React.useState([])
    const [showFilter, setShowFilter] = React.useState(false)
    const [roomData, setRoomData] = React.useState({ typeFileiras: '', posicaoPorta: 0 })
    const [initialData, setInitialData] = React.useState([])
    const [tableData, setTableData] = React.useState([])
    const param = useParams()
    const navigate = useNavigate()
    const [status, setStatus] = React.useState(false);
    const { onChange, values, setValues } = UseOnChange();

    const [searchTerm, setSearchTerm] = useState('');
    const [checkedStatus, setCheckedStatus] = useState(null);

    // VARIAVEL GLOBAL QUE CONTROLA A NAVEGAÇÃO ENTRE AS PÁGINAS DO FLUXO
    const { navigateWay, setNavigateWay } = useContext(NavigateWayContext);
    // navigateWay = {site: '/', room: '', rack: '', map: '', newcount: '', diagram: ''}
    
    const { accounts } = useMsal()

    function postLog(text) {
        axiosInstance.post('logs', {
            email: accounts[0].username,
            name: accounts[0].name,
            action: text
        })
            .catch(err => console.log(err))
    }

    async function updateData() {
        axiosInstance.patch(`racks/${values.id}`, { rack: values, pdu: pdus })
            .then((res) => {
                postLog(`Rack ${values.nrack} in ${param.roomName} updated`)
                getData()
                setValues({})
                setStatus(true)
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async function getData() {
        await axiosInstance(`room/${param.roomid}`)
            .then(res => {
                setRoomData(res.data)
            })
            .catch(err => { console.log(err) })

        await axiosInstance(`racks/room/${param.roomid}`)
            .then(async res => {
                setData(res.data)
                setInitialData(res.data)
                applyFilters(res.data);

                setTableData(
                    res.data.map(rack => ({
                        status: rack.status && rack.reserved ? 'Reserved' : rack.status ? 'Added' : 'Churned',
                        client: rack.clientName,
                        rack: rack.nscala,
                        cage: rack.cage?.name ? rack.cage.name : 'No Cage',
                        created: new Date(rack.createdAt).toLocaleDateString(),
                        nclient: rack?.nrack,
                        occupation: rack.ocupacao,
                        power: rack?.potenciaContratada !== '' ? rack?.potenciaContratada : 'N/A',
                        classification: rack?.classification == null ? 'N/A': rack?.classification,
                        pdus: rack.pduRacks.length > 0 ? rack.pduRacks.map(pdu => (`(${pdu.name} | ${pdu.circuito})`)) : 'No PDUs'
                    }))
                )

            })
            .catch(err => console.log(err))
    }

    React.useState(() => {
        getData()
    }, [])

    function addView(id, index) {
        let div = document.getElementById(id)
        if (div.classList.contains(`expand-circuits`)) {
            if (index + 1 === data.length) {
                div.classList.remove(`invert-order-chart`)
            }
            div.classList.remove(`expand-circuits`)
        } else {
            if (index + 1 === data.length) {
                div.classList.add(`invert-order-chart`)
            }
            div.classList.add(`expand-circuits`)
        }
    }

    const filtros = [
        { nome: "Status", key: "status" },
        // { nome: "Row", key: "fileira" },
        // { nome: "Position", key: "posicao" },
        // { nome: 'Client', key: 'client' }
    ];

    const headers = [
        'Status',
        'Client',
        'Rack',
        'Cages',
        'Created',
        'Number of Client',
        'Occupation',
        'Power',
        'Classification',
        'PDU / Circuit',
    ];
    const columnsWidth = [10, 40, 15, 15, 15, 15, 15, 15, 20, 40]

    let items = type !== 'View Only' ? [
        {
          title: "Data Center",
          img: newDcCinza,
          route: '/'
        }
      ] : [
        {
          title: "Data Center",
          img: newDcCinza,
          route: '/'
        }
    ];

    function applyFilters(dataToFilter = initialData) {
        const filteredData = dataToFilter.filter(item => {
            // Filtra de acordo com o checkbox selecionado
            const statusFilter = checkedStatus === 1 ? item.status && item.reserved === false :
                                 checkedStatus === 2 ? !item.status :
                                 checkedStatus === 3 ? item.reserved : true;
            
            // Filtra de acordo com o termo de busca
            const searchFilter = searchTerm === '' ||
                                 item.clientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                 item.nscala.toLowerCase().includes(searchTerm.toLowerCase());
    
            return statusFilter && searchFilter;
        });
        
        setData(filteredData);
    }

    function handleCheckboxChange(status) {
        setCheckedStatus(status === checkedStatus ? null : status);
    }
    
    function handleSearchChange(newSearchTerm) {
        setSearchTerm(newSearchTerm);
    }

    useEffect(() => {
        applyFilters();
    }, [checkedStatus, searchTerm]);

    return (
        <section className='control-body'>
            <Header line>
                <Breadcrumb
                    site={true}
                    room={true}
                    map={false}
                    newcount={false}
                    diagram={false}
                />
            </Header>
            <button 
                onClick={() => navigate(`/datahall/`, {
                    state: {
                        roomId: param.roomid,
                        roomName: param.roomName,
                        roomData: data,
                        roomInfo: roomData,
                        route: `/details/${param.roomid}/${param.roomName}/${param.date}`
                    }
                })} 
                className='room-map-button' 
            >
                View DH Map
                <img src={chevronWhite} alt='chevron' />
            </button>

            {/*    
                Projected IT Load = mechanical_energy - capacidade de energia da sala       
                Contracted Electrical Load = contracted_energy - total de energia contratada no datahall
                Measured Charge = current_energy - total de energia consumida no datahall
                Cooling Electrical Load = cooling_energy - total de energia reservada para refrigaração
            */}
            <div className='room-info-energy'>
                <div className='room-info-energy-item'>
                    <p>Projected IT Load: </p>
                    <h6>{roomData.mechanical_energy}</h6>
                </div>
                <div className='room-info-energy-item'>
                    <p>Cooling Load: </p>
                    <h6>{roomData.cooling_energy}</h6>
                </div>
                <div className='room-info-energy-item'>
                    <p>Contracted Load: </p>
                    <h6>{roomData.contracted_energy}</h6>
                </div>
                <div className='room-info-energy-item'>
                    <p>Measured Charge: </p>
                    <h6>{roomData.current_energy}</h6>
                </div>

                <div className='room-info-energy-item'>
                    <p>Available Load: </p>
                    <h6>{roomData.mechanical_energy - roomData.contracted_energy}</h6>
                </div>
                <div className='room-info-energy-item'>
                    <p>Limite Load: </p>
                    <h6 style={
                        (roomData.contracted_energy  / roomData.mechanical_energy) * 100 >= 80 &&
                        (roomData.contracted_energy / roomData.mechanical_energy) * 100 <= 89 ?
                        {color:'orange'}
                        : (roomData.contracted_energy / roomData.mechanical_energy) * 100 >= 90 ? 
                        {color:'red'}
                        : {}
                    }>
                        {((roomData.contracted_energy / roomData.mechanical_energy) * 100).toFixed(2)}%
                    </h6>
                </div>

            </div>

            <div className='search-area'>
                <div className='search-position'>
                    <SearchRack 
                        initialData={initialData}
                        onSearch={handleSearchChange} // Usa a função para atualizar o `searchTerm` no estado
                        style={{ border: '1px solid #0F0742', boxShadow: '0 0 0', width: '100%' }}
                        placeholder='Search racks by client or rack name' 
                    />


                    <p style={{ display: "flex", gap: "12px" }}>
                        <div className='search-checkbox1 ajuste_checkbox'>
                            <input type="checkbox" checked={checkedStatus === 1} onChange={() => handleCheckboxChange(1)} />
                            Added
                        </div>
                        <div className='search-checkbox3 ajuste_checkbox'>
                            <input type="checkbox" checked={checkedStatus === 2} onChange={() => handleCheckboxChange(2)} />
                            Churned
                        </div>
                        <div className='search-checkbox2 ajuste_checkbox'>
                            <input type="checkbox" checked={checkedStatus === 3} onChange={() => handleCheckboxChange(3)} />
                            Reserved
                        </div>
                        <div className='search-count'>
                            {data.length} / {initialData.length}
                        </div>                
                    </p>
                </div>

                {/* EXPORT DATA */}
                <Button
                    style={{ width: "15%", height: 40 }}
                    type={'download'}
                    onClick={() => tableDownload(tableData, headers, columnsWidth, `Racks - ${param.roomName} - ${new Date().toLocaleDateString()}`)}
                />

                {/* ADD RACK COUNT */}
                {
                    type == 'View Only' ?
                    <></> :
                    <Button
                        style={{ width: "15%", height: 40 }}
                        label={'Add Rack Count'}
                        onClick={() => 
                            setTimeout(() => {
                                setNavigateWay(prevState => ({
                                    ...prevState,
                                    map: `/site/${navigateWay.room.split('/')[2]}/${navigateWay.room.split('/')[3]}/table`
                                }));
                                navigate(`/site/${navigateWay.room.split('/')[2]}/${navigateWay.room.split('/')[3]}/table`, { 
                                    state: { 
                                        idRoom: navigateWay.rack.split('/')[2], 
                                        nameRoom: navigateWay.rack.split('/')[3], 
                                        dc: navigateWay.room.split('/')[2],
                                        id: navigateWay.room.split('/')[3]
                                    }})
                            }, 100)
                        }
                    />
                }
            </div>
            <section className='table-estructure-rack'>

                <table className='table-estructure-rack_table'>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Client</th>
                            <th>Rack</th>
                            <th>Cages</th>
                            <th>Created</th>
                            <th>Scala Rack Name</th>
                            <th>Ocuppation</th>
                            <th>Power</th>
                            <th>Classification</th>
                            <th>PDU / Circuit</th>
                            {type !== 'View Only' && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((value, index) => {
                                return (
                                    <tr style={value.reserved ? { background: '#E89F1750' } : value.status ? { background: 'rgba(183, 61, 61, 0.30)' } : { background: 'rgba(89, 151, 92, 0.30)' }} key={index}>
                                        <td>{value.reserved ? 'Reserved' : value.status ? 'Added' : 'Churned'}</td>
                                        <td style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '20vw' }}>{value.clientName}</td>
                                        <td>{value.nscala}</td>
                                        <td>{value.cage?.name ? value.cage.name : 'No Cage'}</td>
                                        <td>{new Date(value.createdAt).toLocaleDateString()}</td>
                                        <td>{value?.nscala}</td>
                                        {/* <td>{value?.fileira}</td>
                                        <td>{value?.posicao}</td> */}
                                        <td>{value?.ocupacao}</td>
                                        <td>{value?.potenciaContratada !== '' ? value?.potenciaContratada : 'N/A'}</td>
                                        <td>{value?.classification == null ? 'N/A': value?.classification}</td>
                                        <td>
                                            {
                                                value.pduRacks.length > 0 ?
                                                    <div className='content-circuit'>
                                                        {value.pduRacks.map((val, i) => {
                                                            if (i < 3) {
                                                                return (
                                                                    <div className='card-content-circuit'>
                                                                        <h2>{val.name} | {val.circuito}</h2>
                                                                    </div>
                                                                )
                                                            } else {
                                                                return null
                                                            }
                                                        })}
                                                        <div onMouseEnter={() => addView(`popup-${index}`, index)} onMouseLeave={() => addView(`popup-${index}`, index)} style={{ display: value.pduRacks.length > 3 ? 'flex' : 'none' }} className='plus-content-circuit'>
                                                            <h3>+{value.pduRacks.length - 3}</h3>
                                                            <div id={`popup-${index}`} className='pop-up-circuits'>
                                                                <div className='triangle'></div>
                                                                {value.pduRacks.map((val, i) => {
                                                                    if (i > 2) {
                                                                        return (
                                                                            <div className='card-content-circuit popup-card' key={i}>
                                                                                <h2>{val.name} | {val.circuito}</h2>
                                                                            </div>
                                                                        )
                                                                    } else {
                                                                        return null
                                                                    }
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    'No PDUs'
                                            }
                                        </td>
                                        {type !== 'View Only' && <td><ButtonLess onClick={() => { setValues(value); return setPdus(value.pduRacks) }} type={'edit'} /></td>}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </section>
            {Object.keys(values).length > 0 && <EditRacks save={updateData} pdus={pdus} setPdus={setPdus} values={values} setEditObj={setValues} onChange={onChange} />}
            <FooterStatus
                show={status}
                showButton={false}
                cancel={() => setStatus(false)}
                text={'Rack Updated Successfully'}

            />
        </section >
    )
}

export default Details